/* eslint-disable */
import _ from 'lodash';

const getters = {
  isShopAuthenticated: state => state.authenticated,
  shopToken: state => state.shopToken,
  shopName: state => state.shopName,
  currentShop: state => state.shop,
  currentShopInfo: state => state.shopInfo,
  currentShopId: state => _.get(state, 'shop.shopId', null),
};

export default getters;
